"use client";

import { ChevronRight } from "lucide-react";
import { useTranslations } from "next-intl";

const BEATS: {
  key: "loopIdea" | "loopEngine" | "loopNote" | "loopTerminal" | "loopLive";
  pro?: boolean;
}[] = [
  { key: "loopIdea" },
  { key: "loopEngine" },
  { key: "loopNote" },
  { key: "loopTerminal" },
  { key: "loopLive", pro: true },
];

/**
 * Five-beat closed loop used under the hero and the film.
 */
export function LoopBeats({ className = "" }: { className?: string }) {
  const t = useTranslations("Home");

  return (
    <ol
      className={`mx-auto flex w-full max-w-[20rem] flex-wrap items-center justify-center gap-2 sm:max-w-none ${className}`}
    >
      {BEATS.map((beat, i) => (
        <li key={beat.key} className="flex max-w-full items-center">
          {i > 0 && (
            <ChevronRight
              className="mx-0.5 hidden h-4 w-4 shrink-0 text-teal-light/50 sm:mx-1.5 sm:block"
              aria-hidden
            />
          )}
          <span
            className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide sm:px-3 sm:text-xs ${
              beat.pro
                ? "border-maroon/50 bg-maroon/15 text-slate-100"
                : "border-teal-primary/40 bg-slate-900/60 text-slate-200"
            }`}
          >
            {t(beat.key)}
            {beat.pro ? (
              <span className="rounded bg-maroon px-1.5 py-px text-[10px] font-bold tracking-wider text-white">
                {t("loopLiveBadge")}
              </span>
            ) : null}
          </span>
        </li>
      ))}
    </ol>
  );
}
